import { render, staticRenderFns } from "./strength.vue?vue&type=template&id=5b6fb1f2&scoped=true&"
import script from "./strength.vue?vue&type=script&lang=js&"
export * from "./strength.vue?vue&type=script&lang=js&"
import style0 from "./strength.vue?vue&type=style&index=0&id=5b6fb1f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b6fb1f2",
  null
  
)

export default component.exports